import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=114d143d&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('114d143d')) {
      api.createRecord('114d143d', component.options)
    } else {
      api.reload('114d143d', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=114d143d&", function () {
      api.rerender('114d143d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20PG6paUVJ6g1/JS/comp/FavElement.vue"
export default component.exports